import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./index.scss";

export const ActiveCleeSection = ({ product, id }) => {
  const [slidesToShow, setSlidesToShow] = useState(5);
  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 480) setSlidesToShow(1);
    else if (width <= 768) setSlidesToShow(2);
    else if (width <= 1300) setSlidesToShow(3);
    else if (width <= 1600) setSlidesToShow(4);
    else setSlidesToShow(5);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const sliderRef = useRef(null);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false, // Direction de droite à gauche
    pauseOnHover: true,
  };
  return (
    <div className="temoignage-home ">
      <div className="row  justify-content-center  ">
        <div className="col-lg-3">
          <div className="temoignage-home-title">Actifs clés</div>
          <div className="temoignage-home-text">
            Nos produits sont formulés à partir d’ingrédients naturels
            soigneusement sélectionnés pour leurs bienfaits.
          </div>
        </div>
        <div className="col-lg-9 mt-3 mt-md-0 ">
          <Slider {...settings} ref={sliderRef}>
            {product.map((product, index) => (
              <div className="house-card" key={index}>
                <div className="image-wrapper">
                  <img
                    src={`https://api.almasecret.msit-demo.fr/products/${id}/activeClee/${index}`}
                    alt="Maison"
                  />

                  <div className="overlay">
                    <p className="title">{product?.titre}</p>
                    <p className="description">{product?.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};
